import { Box, Stack, TableCell, Typography } from '@mui/material'
import type { ReactNode } from 'react'

export type BidDetailActivationGroupCellProps = Readonly<{
  rowSpan: number
  code: string
  subLabel?: string
  /** Per-AG mini-stat slot (e.g. per-AG offered total). */
  meta: ReactNode
  dimmed?: boolean
}>

/**
 * Second-left cell, `rowspan`'d across the step rows of one AG within one
 * PTU. Pure presentation; no bid-type knowledge.
 */
export default function BidDetailActivationGroupCell({
  rowSpan,
  code,
  subLabel,
  meta,
  dimmed = false,
}: BidDetailActivationGroupCellProps) {
  return (
    <TableCell
      rowSpan={rowSpan}
      sx={{
        verticalAlign: 'top',
        borderRight: 1,
        borderRightColor: 'divider',
        minWidth: 100,
        opacity: dimmed ? 0.5 : 1,
      }}
    >
      <Stack spacing={0.5}>
        <Typography fontWeight={500} variant="body2">
          {code}
        </Typography>
        {subLabel && (
          <Typography color="text.secondary" variant="caption">
            {subLabel}
          </Typography>
        )}
        <Box>{meta}</Box>
      </Stack>
    </TableCell>
  )
}
